import { createSlice, current } from '@reduxjs/toolkit';
import { createProject, updateProject, getProjects, deleteProjects } from '../../thunks/admin/projects';
import { mergeArrayByKey } from '../../../utils/helpers/data';

export const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    currentPage: 1,
    limit: 50,
    totalDocs: 0,

    isCreating: false,
    isUpdating: {},
    isFetching: false,
  },

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getProjects.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getProjects.fulfilled]: (state, action) => {
      const { projects, totalDocs } = action.payload;

      state.totalDocs = totalDocs;
      
      const currentState = current(state);
      state.projects = currentState.currentPage === 1 ? [...projects] : mergeArrayByKey([...currentState.projects, ...projects], '_id');
    
      state.isFetching = false;
    },
    [getProjects.rejected]: (state, action) => {
      const currentState = current(state);
      if (currentState.currentPage === 1) {
        state.projects = [];
        state.totalDocs = 0;
      }
      state.isFetching = false;
    },
    
    [createProject.pending]: (state, action) => {
      state.isCreating = true;
    },
    [createProject.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.projects.push(action.payload);
      state.totalDocs = currentState.totalDocs + 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      state.isCreating = false;
    },
    [createProject.rejected]: (state, action) => {
      state.isCreating = false;
    },

    [updateProject.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = true;
    },
    [updateProject.fulfilled]: (state, action) => {
      const currentState = current(state);
      const updatedProject = action.payload;
      state.projects = currentState.projects.map(project => project._id === updatedProject._id ? updatedProject : project);
      state.isUpdating[updatedProject._id] = false;
    },
    [updateProject.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = false;
    },

    [deleteProjects.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      state.projects = currentState.projects.filter(({ _id }) => !ids.includes(_id));
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    }
  }
});

export const { setCurrentPage } = projectsSlice.actions;

export default projectsSlice.reducer;
